// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"campaigns-outage-main__container___1_-CD","intro":"campaigns-outage-main__intro___1KaU4","icon":"campaigns-outage-main__icon___IB3Xv"};
    if(module.hot) {
      // 1754439432880
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  